import React from 'react';
import { ArrowLeft } from 'react-feather';
import { routes } from 'constants/config';
import PreserveFormatting from 'components/shared/PreserveFormatting/index';
import Text, { TEXT_VARIANTS } from 'components/ui/Typography/Text';

const EventRegistrationOverviewHeader = ({ event, session }) => (
  <div className="EventRegistrationHeader">
    <div>
      <a
        href={routes.IN_PERSON_TRAINING.EVENTS_DASHBOARD}
        className="EventRegistrationHeader-Link"
      >
        <ArrowLeft className="EventRegistrationHeader-Link-Icon" size={24} />
        {t('in_person_training.events.my_training_events')}
      </a>
      <div className="d-f jc-sb ai-fs mb-16">
        <h1 className="ff-ss ws-pr mr-8">{event.name}</h1>
      </div>
      <p className="fz-bigger">
        <Text variant={TEXT_VARIANTS.BODY_LIGHT}>
          <PreserveFormatting>{event.description}</PreserveFormatting>
        </Text>
      </p>
    </div>
  </div>
);

export default EventRegistrationOverviewHeader;
